<app-base-dialog sizeClass="size-12-25" [noPadding]="true">
	<div>
		<div class="optie" (click)="openProductboard()">
			<app-icon name="ideeenbord" size="small" color="primary-1" hoverColor="secondary-1"></app-icon>
			<span>Ideeënbord</span>
		</div>
		<div class="optie" (click)="openFeedbackDialog()">
			<app-icon name="feedback" size="small" color="primary-1" hoverColor="secondary-1"></app-icon>
			<span>Feedback geven</span>
		</div>
	</div>
</app-base-dialog>
